module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAICAYAAACRbl3VAAAAbUlEQVQ4jb2S0QmAMAwFr1Jn0h/Bfzd1EQdwHMGUooKGIlFI7ye0hMc1TeCgByb8WIG5lC4ij3NQ1RMpZWuheN1XEDLxdTL5AR3QOPlINDTdaYHhrC5CNXbn3UDtkNfof5O/bHTM34EF2EzdQAIzthKLj3SwJQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/common/images/newsCenter/more.png
// module id = 8wH+
// module chunks = 0